export const logos: Record<string, string> = {
    novasol: 'logo/77611323/20221019/52940735-7c01-4d6c-a3c7-ebc1c883fd9b',
    interhome: 'logo/1917779154/20250611/8a505e22-5504-458c-824a-5fa83d81bcc0',
    dancenter: 'logo/447085521/20230525/0d46e4a3-996b-493e-bae3-65b6e8d117ce',
    belvilla: 'logo/1260096187/20230525/a7a87b4a-b77c-42c6-9506-d1535d66aeee',
    sologstrand: 'logo/1920655877/20220627/0f68b1e2-843e-45c0-8937-e078fb260968',
    danland: 'logo/4594972/20230525/6e06ccd0-380d-4c1e-90c6-a3f8fbcf356d',
    yourrentals: 'logo/6924338/20221012/2738e557-a72a-4c3f-9dc8-bd414c284ad0',
    cabinliving: 'logo/8725782/20200525/43b28e8c-941b-4ae4-90d6-0cbcbdce051b',
    costablanca: 'logo/6364108/20260108/613f1feb-e752-4a21-9957-70a179d83e1f',
    bonavidaspain: 'logo/6833232/20241029/9426af36-81d9-4012-9266-de302242d52a',
};
